import ClientNavbar from "../components/ClientNavbar";
import Hero from "../components/Hero";
import CategorySection from "../components/CategorySection";
import FeaturedExams from "../components/FeaturedExams";
import WhyChooseUs from "../components/WhyChooseUs";
import AdBanner from "../components/AdBanner";
import LatestExams from "../components/LatestExams";
import StatsSection from "../components/StatsSection";
import Footer from "../components/Footer";

function Home() {
  return (
    <>
      <ClientNavbar />

      <Hero />

      <CategorySection />

      <FeaturedExams />

      <WhyChooseUs />

      <AdBanner />

      <LatestExams />

      <StatsSection />

      <Footer />

    </>
  );
}

export default Home;